export class ApplicationToComponentStrategyResolverException {
  // eslint-disable-next-line no-useless-constructor
  constructor (
    public readonly message: string,
    public readonly id: string
  ) {}

  public static fittingStrategyNotFoundId = 'application_to_component_strategy_resolver_fitting_strategy_not_found'

  public static fittingStrategyNotFound (): ApplicationToComponentStrategyResolverException {
    return new ApplicationToComponentStrategyResolverException(
      'No fitting strategy found',
      this.fittingStrategyNotFoundId
    )
  }
}
